import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { initConsoleCommands } from './core/consoleCommands'
import { initSentry } from './core/sentry'

// Import global styles
import './styles/main.css'

// Initialize DevTools console commands (rws.productivity.visible = false/true)
initConsoleCommands()

// Create app instance
const app = createApp(App)

// Initialize Sentry monitoring & error capture
initSentry({ app, router })

// Install plugins
app.use(createPinia())
app.use(router)

// Mount app
app.mount('#app')
